import {
  Box,
  Button,
  Card,
  CardContent,
  DialogActions,
  DialogTitle,
  Divider,
  Grid,
  Modal,
  Typography,
} from "@mui/material";
import { ModalHeader } from "../../common/modalHeader";
import { useEffect, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { htmlToPDF } from "../../common/printBillingApi";
import { useSelector } from "react-redux";

export const EmployeeSalarySlipModal = ({ modalData, open, setOpen }) => {
  const actvieBussinessDetails = useSelector(
    (state) => state.reducer.actvieBussinessDetails
  );
  useEffect(() => {
    let data = modalData;
    console.log("openModal ", data);
  }, [modalData]);
  const receptRef = useRef(null);

  const convertNumberToWords = (amount) => {
    if (typeof amount !== "number") {
      amount = parseFloat(amount);
    }

    if (isNaN(amount)) return "Zero";

    const singleDigits = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const twoDigits = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tensMultiple = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const scales = ["", "Thousand", "Lakh", "Crore"];

    const numToWords = (num) => {
      let str = "";

      if (num > 99999999) {
        str += numToWords(Math.floor(num / 10000000)) + " Crore ";
        num %= 10000000;
      }
      if (num > 99999) {
        str += numToWords(Math.floor(num / 100000)) + " Lakh ";
        num %= 100000;
      }
      if (num > 999) {
        str += numToWords(Math.floor(num / 1000)) + " Thousand ";
        num %= 1000;
      }
      if (num > 99) {
        str += singleDigits[Math.floor(num / 100)] + " Hundred ";
        num %= 100;
      }
      if (num > 9 && num < 20) {
        str += twoDigits[num - 10] + " ";
      } else if (num > 0) {
        str +=
          tensMultiple[Math.floor(num / 10)] +
          (num % 10 !== 0 ? " " + singleDigits[num % 10] : "") +
          " ";
      }

      return str.trim();
    };

    const [integerPart, decimalPart] = amount.toFixed(2).toString().split(".");

    let result = numToWords(parseInt(integerPart));
    if (decimalPart && parseInt(decimalPart) > 0) {
      result +=
        " Point " +
        decimalPart
          .split("")
          .map((d) => singleDigits[parseInt(d)])
          .join(" ");
    }

    return result || "Zero";
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "90%", sm: "40%", md: "40%", lg: "30%", xl: "30%" },

          overflowY: "auto",
          // height: "90vh",
          borderRadius: "10px",
          position: "absolute",
          left: { xs: "2%", sm: "25%", md: "35%", lg: "35%", xl: "35%" },

          top: "10%",
        }}
      >
        {/* <ModalHeader
          title={"Salary Slip"}
          onClose={(data) => {
            setOpen(data);
          }}
        /> */}

        <DialogTitle
          color="primary"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: "bold",
            padding: "10px 15px",
            fontSize: { xs: "12px", sm: "13px", md: "15px" },
          }}
        >
          Salary Slip{" "}
          <CloseIcon
            sx={{
              float: "right",
              color: "#000000",
              fontSize: "30px",
              cursor: "pointer",
            }}
            onClick={() => setOpen(false)}
          />
        </DialogTitle>

        <Card sx={{ maxWidth: 600, mx: "auto" }}>
          <CardContent>
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  color="primary"
                  sx={{
                    fontWeight: "800",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Payslip for the month of{" "}
                  {modalData?.fromDate
                    ? new Date(modalData.fromDate).toLocaleString("en-US", {
                        month: "long",
                        year: "numeric",
                      })
                    : "N/A"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  gap: 1,
                  mt: 1,
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "medium",
                  }}
                >
                  Name
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  {modalData?.emaployeeName || "N/A"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  gap: 1,
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "medium",
                  }}
                >
                  Joining Date
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: "medium",
                  }}
                >
                  {modalData?.fromDate
                    ? (() => {
                        const date = new Date(modalData.doj);
                        const day = date.getDate().toString().padStart(2, "0");
                        const month = date.toLocaleString("en-US", {
                          month: "long",
                        });
                        const year = date.getFullYear();
                        return `${day} ${month} ${year}`;
                      })()
                    : "N/A"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  gap: 1,
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "medium",
                  }}
                >
                  Location
                </Typography>
                <Typography
                  sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
                >
                  {modalData?.location || "N/A"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  gap: 1,
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "medium",
                  }}
                >
                  Emp ID
                </Typography>
                <Typography
                  sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
                >
                  {modalData?.employeeId || "N/A"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ borderTop: "2px dotted #000000", py: 1 }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontWeight: "800",

                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Earnings
                </Typography>
                <Typography
                  color="primary"
                  sx={{
                    fontWeight: "800",

                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Actual
                </Typography>
              </Grid>

              {/* {modalData?.allSalaryComponents?.map((component) => (
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography color="primary">
                    {component.componentName}:
                  </Typography>
                  <Typography>
                    ₹ {parseFloat(component.amount).toFixed(2) || "0.00"}
                  </Typography>
                </Grid>
              ))} */}

              {/* {modalData?.allOtherAllowances?.map((component) => (
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography color="primary">
                    {component.allowanceName}:
                  </Typography>
                  <Typography>
                    ₹ {parseFloat(component.amount).toFixed(2) || "0.00"}
                  </Typography>
                </Grid>
              ))} */}

              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "medium",
                  }}
                >
                  Incentive Amount
                </Typography>
                <Typography fontSize={{ xs: "12px", sm: "13px", md: "15px" }}>
                  ₹{" "}
                  {parseFloat(modalData?.incentiveAmount).toFixed(2) || "0.00"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "medium",
                  }}
                >
                  Total Earning (INR)
                </Typography>
                <Typography fontSize={{ xs: "12px", sm: "13px", md: "15px" }}>
                  ₹ {modalData?.totalEarnings || "0.00"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ borderTop: "2px dotted #000000", py: 1 }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontWeight: "800",

                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Deductions
                </Typography>
                <Typography
                  color="primary"
                  sx={{
                    fontWeight: "800",

                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Actual
                </Typography>
              </Grid>

              {/* {modalData?.allDeductionsComponents?.map((component) => (
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography color="primary">
                    {component.componentName}:
                  </Typography>
                  <Typography>
                    ₹ {parseFloat(component.amount).toFixed(1) || "0.00"}
                  </Typography>
                </Grid>
              ))} */}

              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "medium",
                  }}
                >
                  Deduction
                </Typography>
                <Typography fontSize={{ xs: "12px", sm: "13px", md: "15px" }}>
                  ₹ {modalData?.deduction || "0.0"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "medium",
                  }}
                >
                  Advance Paid
                </Typography>
                <Typography fontSize={{ xs: "12px", sm: "13px", md: "15px" }}>
                  ₹ {parseFloat(modalData?.advancePaid).toFixed(1) || "0.00"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography
                  color="primary"
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "medium",
                  }}
                >
                  Total Deductions: INR
                </Typography>
                <Typography fontSize={{ xs: "12px", sm: "13px", md: "15px" }}>
                  ₹{" "}
                  {parseFloat(modalData?.totalDeductions).toFixed(1) || "0.00"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{ py: 1, display: "flex", justifyContent: "space-between" }}
              >
                <Grid>
                  <Typography
                    color="primary"
                    sx={{
                      fontWeight: "600",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    Net Pay for the Month
                  </Typography>
                  <Typography
                    color="primary"
                    sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
                  >
                    (Total Earnings - Total Deduction)
                  </Typography>
                </Grid>
                <Typography
                  color="primary"
                  sx={{
                    fontWeight: "800",
                    textAlign: "center",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  {" "}
                  {modalData?.totalEarnings - modalData?.totalDeductions ||
                    "0.00"}
                </Typography>
              </Grid>
            </Grid>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={async () => {
                  console.log("hit download");
                  // htmlToPDF(receptRef);
                  const blob = await htmlToPDF(receptRef);
                  if (blob) {
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = "SalarySlip.pdf";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                  }
                }}
                variant="contained"
                sx={{
                  width: "60%",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Download
              </Button>
            </Box>
          </CardContent>
        </Card>
        {/* ........................ */}
        <Card
          sx={{
            maxWidth: 800,
            mx: "auto",
            p: 2,
            position: "fixed",
            top: 0,
            left: 0,
            opacity: 0,
            pointerEvents: "none",
            zIndex: -999,
          }}
        >
          <Box
            ref={receptRef}
            sx={{ position: "relative", minHeight: "1122px", mx: "auto" }}
          >
            {/* Header */}
            {/* Header with Logo and Title Side by Side */}
            {/* Title Centered */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                px: 2,
                pt: 2,
                flexDirection: "row",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: "18px",
                  textAlign: "center",
                  flexGrow: 1,
                }}
              >
                {actvieBussinessDetails?.enterpriseName || "PALACE THE SALON"}
              </Typography>
              <Box
                component="img"
                src={actvieBussinessDetails?.logoPath}
                sx={{ width: 80, height: 80, borderRadius: "50%" }}
              />
            </Box>

            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: 700,
                textAlign: "center",
                mt: 1,
              }}
            >
              Payslip for the month of{" "}
              {modalData?.fromDate
                ? new Date(modalData.fromDate).toLocaleString("en-US", {
                    month: "long",
                    year: "numeric",
                  })
                : "N/A"}
            </Typography>

            {/* Employee Info */}
            <Box sx={{ display: "flex", border: "3px solid black" }}>
              <Box sx={{ flex: 1, p: 1, borderRight: "3px solid black" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    px: 1,
                  }}
                >
                  <Typography>Name: </Typography>
                  <Typography sx={{ textAlign: "left" }}>
                    {modalData?.emaployeeName || "N/A"}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    px: 1,
                  }}
                >
                  <Typography>Join Date: </Typography>
                  <Typography sx={{ textAlign: "left" }}>
                    {modalData?.fromDate
                      ? (() => {
                          const date = new Date(modalData.doj);
                          const day = date
                            .getDate()
                            .toString()
                            .padStart(2, "0");
                          const month = date.toLocaleString("en-US", {
                            month: "long",
                          });
                          const year = date.getFullYear();
                          return `${day} ${month} ${year}`;
                        })()
                      : "N/A"}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    px: 1,
                  }}
                >
                  <Typography> Designation:- </Typography>
                  <Typography sx={{ textAlign: "left" }}>
                    {modalData?.designation || "N/A"}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ flex: 1, p: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    px: 1,
                  }}
                >
                  <Typography> Location: </Typography>
                  <Typography>{modalData?.location || "N/A"}</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    px: 1,
                  }}
                >
                  <Typography> Effective Work Days: </Typography>
                  <Typography>{modalData?.workingDays || "N/A"}</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    px: 1,
                  }}
                >
                  <Typography> Days In Month: </Typography>
                  <Typography>{modalData?.workingDays || "N/A"}</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    px: 1,
                  }}
                >
                  <Typography> Emp ID: </Typography>
                  <Typography>{modalData?.employeeId || "N/A"}</Typography>
                </Box>
              </Box>
            </Box>

            {/* Earnings and Deductions */}
            <Box
              sx={{
                display: "flex",
                border: "3px solid black",
                borderTop: "none",
              }}
            >
              {/* Earnings */}
              <Box sx={{ flex: 1, borderRight: "3px solid black" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    p: 1,
                    borderBottom: "3px solid black",
                    fontWeight: "bold",
                  }}
                >
                  <Typography>Earnings</Typography>
                  <Typography>Actual</Typography>
                </Box>
                {modalData?.allSalaryComponents?.map((item, index) => (
                  <Box
                    key={`allowance-${index}`}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      px: 1,
                    }}
                  >
                    <Typography>{item.componentName}</Typography>
                    <Typography>{item.amount.toFixed(2)}</Typography>
                  </Box>
                ))}
                {modalData?.allOtherAllowances?.map((item, index) => (
                  <Box
                    key={`allowance-${index}`}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      px: 1,
                    }}
                  >
                    <Typography>{item.allowanceName}</Typography>
                    <Typography>{item.amount.toFixed(2)}</Typography>
                  </Box>
                ))}

                {modalData?.incentiveAmount > 0 && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      px: 1,
                    }}
                  >
                    <Typography>Incentive</Typography>
                    <Typography>
                      {modalData.incentiveAmount.toFixed(2)}
                    </Typography>
                  </Box>
                )}
              </Box>

              {/* Deductions */}
              <Box sx={{ flex: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    p: 1,
                    borderBottom: "3px solid black",
                    fontWeight: "bold",
                  }}
                >
                  <Typography>Deductions</Typography>
                  <Typography>Actual</Typography>
                </Box>
                {modalData?.allDeductionsComponents?.map((item, index) => (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      px: 1,
                    }}
                  >
                    <Typography>{item.componentName}</Typography>
                    <Typography>{item.amount}</Typography>
                  </Box>
                ))}
              </Box>
            </Box>

            {/* Totals */}
            <Box
              sx={{
                display: "flex",
                border: "3px solid black",
                borderTop: "none",
                fontWeight: "bold",
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "space-between",
                  p: 1,
                  borderRight: "3px solid black",
                }}
              >
                <Typography>Total Earnings: INR.</Typography>
                <Typography>₹ {modalData?.totalEarnings || "0.00"}</Typography>
              </Box>
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "space-between",
                  p: 1,
                }}
              >
                <Typography>Total Deductions: INR.</Typography>
                <Typography>
                  {" "}
                  ₹{" "}
                  {parseFloat(modalData?.totalDeductions).toFixed(1) || "0.00"}
                </Typography>
              </Box>
            </Box>

            {/* Net Pay */}
            <Box sx={{ border: "3px solid black", borderTop: "none", p: 2 }}>
              <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
                Net Pay for the month
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  mb: 1,
                  fontWeight: "bold",
                }}
              >
                (Total Earnings - Total Deductions):{" "}
                <strong> {modalData?.amount || "0.00"}</strong>
              </Typography>
              <Typography>
                ({convertNumberToWords(modalData?.amount || 0)})
              </Typography>
            </Box>
            {/* Footer */}
            <Box
              sx={{
                position: "absolute",
                bottom: 10, // distance from bottom of page
                left: 0,
                right: 0,
                textAlign: "center",
                fontFamily: "cursive",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                PALACE THE SALON -{" "}
                <span style={{ fontStyle: "italic" }}>Wakadewadi</span>
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 500, fontSize: "13px", fontStyle: "italic" }}
              >
                palacethesalon@gmail.com
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>
    </Modal>
  );
};
